export function sanitizeRedirectPath(
  raw: string | null | undefined,
  fallback = '/account/'
): string {
  if (raw == null) return fallback
  const trimmed = raw.trim()
  if (!trimmed) return fallback
  if (!trimmed.startsWith('/')) return fallback
  if (trimmed.startsWith('//')) return fallback
  if (trimmed.includes('..')) return fallback
  return trimmed
}
